import React, {useState, useContext} from 'react';
import {updateToDoList} from '../../../services/MadricService';
import Spinner from '../../Spinner/Spinner';
import UpdateToDoListView from './UpdateToDoListView';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function UpdateToDoList(props) {
  const [inputValue, setInputValue] = useState(props.todolist.description);
  const [complete, setComplete] = useState(props.todolist.complete);
  const [errors, setErrors] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {setProjectInfo} = useContext(MadricContext);


  /**
   * Permet de update la todolist
   */
  async function handleSubmit() {
    if (inputValue === '' || inputValue === null) {
      setErrors('La description de la tâche ne peut pas être vide.');
    } else {
      setIsLoading(true);

      const res = await updateToDoList(props.todolist.id, inputValue, complete);
      props.closeModal();

      setProjectInfo((previous) => previous.map((item) => {
        if (item.id === props.todolist.id && item.type === 'todolist') {
          return res;
        }
        return item;
      }).sort((a, b) => (a.complete === b.complete) ? 0 : a.complete ? 1 : -1));
      setIsLoading(false);
    }
  }

  return (
    <div>
      {isLoading && <Spinner />}
      <UpdateToDoListView
        inputValue={inputValue}
        setInputValue={setInputValue}
        closeModal={props.closeModal}
        complete={complete}
        setComplete={setComplete}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </div> 
  );
}

export default UpdateToDoList;